module.exports = __webpack_public_path__ + "static/media/eth.be78bc84.png";